import { render, staticRenderFns } from "./ItopsIssueList.vue?vue&type=template&id=b76920f8&"
import script from "./ItopsIssueList.vue?vue&type=script&lang=js&"
export * from "./ItopsIssueList.vue?vue&type=script&lang=js&"
import style0 from "./ItopsIssueList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports